import React from 'react';

const NewCreditOfferedFilterIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8.50002 5.83325H3.03032C2.27721 5.83325 1.66669 6.43953 1.66669 7.18742V15.3124C1.66669 16.0603 2.27721 16.6666 3.03032 16.6666H15.3031C16.0562 16.6666 16.6667 16.0603 16.6667 15.3124V13.7499"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M1.66669 10H8.16669" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M10.3669 7.78055L12.8669 6.28055L14.3669 3.78055L15.8669 6.28055L17.8669 7.78055L15.8669 9.28055L14.3669 11.7806L12.8669 9.28055L10.3669 7.78055Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default NewCreditOfferedFilterIcon;
